import { ActionType } from './types';
import * as api from './api';
export { fetchIngameBalance } from '@profile/src/redux/remoteActions';

const fetchVestingSafeConfigsRequested = () => ({
  type: ActionType.FETCH_VESTING_SAFE_CONFIG_REQUESTED,
  payload: undefined
});

const fetchVestingSafeConfigsFailure = error => ({
  type: ActionType.FETCH_VESTING_SAFE_CONFIG_FAILURE,
  payload: {
    error
  }
});

const fetchVestingSafeConfigsSuccess = data => ({
  type: ActionType.FETCH_VESTING_SAFE_CONFIG_SUCCESS,
  payload: {
    data
  }
});

export const fetchVestingSafeConfigs = () => async dispatch => {
  dispatch(fetchVestingSafeConfigsRequested());
  const response = await api.getVestingSafeConfigs({});

  if (response.status === 'error') {
    dispatch(fetchVestingSafeConfigsFailure(response.error));
    return {
      error: response.error
    };
  }

  const {
    data
  } = response.body;
  dispatch(fetchVestingSafeConfigsSuccess(data));
  return {
    data
  };
};

const fetchVestingSafeRequested = () => ({
  type: ActionType.FETCH_VESTING_SAFE_REQUESTED,
  payload: undefined
});

const fetchVestingSafeFailure = error => ({
  type: ActionType.FETCH_VESTING_SAFE_FAILURE,
  payload: {
    error
  }
});

const fetchVestingSafeSuccess = data => ({
  type: ActionType.FETCH_VESTING_SAFE_SUCCESS,
  payload: {
    data
  }
});

export const fetchVestingSafe = () => async dispatch => {
  dispatch(fetchVestingSafeRequested());
  const response = await api.getVestingSafe({});

  if (response.status === 'error') {
    dispatch(fetchVestingSafeFailure(response.error));
    return {
      error: response.error
    };
  }

  const {
    data
  } = response.body;
  dispatch(fetchVestingSafeSuccess(data));
  return {
    data
  };
};

const fetchVestingSafeRemainingClaimRequested = () => ({
  type: ActionType.FETCH_VESTING_SAFE_REMAINING_CLAIM_COUNT_REQUESTED,
  payload: undefined
});

const fetchVestingSafeRemainingClaimFailure = error => ({
  type: ActionType.FETCH_VESTING_SAFE_REMAINING_CLAIM_COUNT_FAILURE,
  payload: {
    error
  }
});

const fetchVestingSafeRemainingClaimSuccess = data => ({
  type: ActionType.FETCH_VESTING_SAFE_REMAINING_CLAIM_COUNT_SUCCESS,
  payload: {
    data
  }
});

export const fetchVestingSafeRemainingClaim = () => async dispatch => {
  dispatch(fetchVestingSafeRemainingClaimRequested());
  const response = await api.getVestingSafeRemainingClaimCount({});

  if (response.status === 'error') {
    dispatch(fetchVestingSafeRemainingClaimFailure(response.error));
    return {
      error: response.error
    };
  }

  const {
    data
  } = response.body;
  dispatch(fetchVestingSafeRemainingClaimSuccess(data));
  return {
    data
  };
};

const fetchClaimVestingSafeRequested = () => ({
  type: ActionType.FETCH_CLAIM_VESTING_SAFE_REQUESTED,
  payload: undefined
});

const fetchClaimVestingSafeFailure = error => ({
  type: ActionType.FETCH_CLAIM_VESTING_SAFE_FAILURE,
  payload: {
    error
  }
});

const fetchClaimVestingSafeSuccess = data => ({
  type: ActionType.FETCH_CLAIM_VESTING_SAFE_SUCCESS,
  payload: {
    data
  }
});

export const fetchClaimVestingSafe = () => async dispatch => {
  dispatch(fetchClaimVestingSafeRequested());
  const response = await api.postClaimVestingSafe({});

  if (response.status === 'error') {
    dispatch(fetchClaimVestingSafeFailure(response.error));
    return {
      error: response.error
    };
  }

  const {
    data
  } = response.body;
  dispatch(fetchClaimVestingSafeSuccess(data));
  return {
    data
  };
};